import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Currency, getFormattedDate, getFormattedFloat, getFormattedPrice, getFormattedTime, getHumanReadableDuration, } from "@msys/formatting";
import { Typography } from "@mui/material";
import { BigNumber } from "bignumber.js";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
export const FormattedPercentage = ({ value, notSetText = "–", }) => {
    const locale = useLocale();
    function renderPercentage() {
        if (typeof value === "number") {
            return getFormattedFloat(value * 100, locale) + "%";
        }
        else if (BigNumber.isBigNumber(value)) {
            return getFormattedFloat(value.toNumber() * 100, locale) + "%";
        }
        else if (value) {
            return getFormattedFloat(value.amount * 100, locale) + "%";
        }
        else {
            return notSetText;
        }
    }
    return _jsx(React.Fragment, { children: renderPercentage() });
};
export const FormattedPrice = ({ value, isPlaceholder, showFallback = true, notSetText = "–", }) => {
    const locale = useLocale();
    function renderPrice() {
        if (isPlaceholder) {
            return renderPlaceholder(Currency.Eur);
        }
        else if (typeof value === "number") {
            return getFormattedPrice(value, locale);
        }
        else if (BigNumber.isBigNumber(value)) {
            return getFormattedPrice(value.toNumber(), locale);
        }
        else if (value) {
            return getFormattedPrice(value.amount, locale);
        }
        else {
            return showFallback ? notSetText : null;
        }
    }
    return _jsx(React.Fragment, { children: renderPrice() });
};
function renderPlaceholder(currency) {
    return (_jsxs(Typography, { component: "p", style: { textDecoration: "underline" }, children: [Array.from({ length: 14 }).map((_v, idx) => (_jsx(React.Fragment, { children: "\u00A0" }, idx))), currency] }));
}
export const FormattedTime = ({ value, notSetText = "–", }) => {
    if (!value)
        return _jsx(React.Fragment, { children: notSetText });
    const numberValue = BigNumber.isBigNumber(value)
        ? value.toNumber()
        : value;
    const { hours, min } = getFormattedTime(numberValue);
    const timeString = hours + ":" + String(min).padStart(2, "0") + "h";
    return _jsx(React.Fragment, { children: timeString });
};
export const FormattedDate = ({ date, notSetText = "–", }) => {
    const locale = useLocale();
    if (!date)
        return _jsx(_Fragment, { children: notSetText });
    return _jsx(_Fragment, { children: getFormattedDate(date, locale) });
};
export const Duration = ({ duration, notSetText = "–", }) => {
    const locale = useLocale();
    if (!duration)
        return _jsx(_Fragment, { children: notSetText });
    return _jsx(_Fragment, { children: getHumanReadableDuration(duration, locale) });
};
//# sourceMappingURL=FormattedValue.js.map